import { Button, Dialog, IconButton } from "@material-ui/core"
import CloseIcon from "@material-ui/icons/Close"
import FileCopyIcon from "@material-ui/icons/FileCopy"
import { PropTypes } from "prop-types"
import { useContext, useEffect, useState } from "react"
import CopyToClipboard from "react-copy-to-clipboard"
import { useQuery } from "react-query"
import { listCourses } from "~/actions/courses"
import { createAppDemoUser, getDemoToken } from "~/actions/users"
import AppContext from "~/contexts/App"

export default function DemoTokenDialog({
  open,
  firstName,
  lastName,
  handleCloseToken,
  currentRefetchId,
  setCurrentRefetchId,
  showCourse,
  showMeta,
  setShowCourse,
  setShowMeta,
}) {
  const [tokenState, setToken] = useState()
  const [redirectUrl, setRedirectUrl] = useState("/channels/meta-quest")

  const { openSnackBar } = useContext(AppContext)
  const [courseIdSelect, setCourseIdSelect] = useState(18)

  const courses = useQuery("courses", listCourses, {
    enabled: true,
  })

  const mqRange = { min: 55, max: 61 }

  const fbRange = { min: 43, max: 45 }

  var filteredCourses = courses?.data?.filter(function (o) {
    return o.published === 1
    // return (
    //   (o.container_id > mqRange.max || o.container_id < mqRange.min) &&
    //   (o.container_id > fbRange.max || o.container_id < fbRange.min) &&
    //   o.container_id !== 16 &&
    //   o.published === 1
    // )
  })

  const { data: token, refetch } = useQuery(
    "demo-token",
    () => getDemoToken(currentRefetchId),
    {
      enabled: open,
    },
  )

  useEffect(() => {
    if (token) {
      setToken(token.token)
    }
  }, [token])

  const createDemoUser = async () => {
    if (currentRefetchId) {
      refetch()
      setCurrentRefetchId(null)
    } else {
      setToken(null)
      const result = await createAppDemoUser({
        first_name: firstName,
        last_name: lastName,
      })
      setToken(result.data.token)
    }
  }

  const changeSelected = (e) => {
    const $select = document.querySelector("#course-select2")
    setCourseIdSelect($select.value)
  }

  return (
    <Dialog open={open} maxWidth="sm">
      <div
        className="flex flex-col space-y-4 text-base"
        style={{
          padding: "30px 40px",
          paddingBottom: "40px",
          width: "100%",
        }}
      >
        <div className="flex justify-between items-center w-full">
          <p style={{ fontSize: 18, marginBottom: 0 }}>
            {firstName && lastName
              ? `Create Demo User:
            ${lastName}, ${firstName}`
              : "Create Demo User"}
          </p>
          <IconButton
            onClick={() => {
              setToken(null)
              handleCloseToken()
            }}
          >
            <CloseIcon />
          </IconButton>
        </div>
        <>
          <div className="flex flex-col gap-y-2">
            <p className="text-base">Redirect to URL:</p>
            <input
              className="block w-full rounded-md border-0 px-2 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-black sm:text-sm sm:leading-6"
              value={redirectUrl || "/channels/meta-quest"}
              onChange={(e) => {
                setRedirectUrl(e.target.value)
              }}
            />
            {!tokenState && !showMeta && (
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  createDemoUser()
                  setShowMeta(true)
                }}
              >
                Get Meta Link
              </Button>
            )}
            {tokenState && !showMeta && (
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  setShowMeta(true)
                }}
              >
                Get URL Link
              </Button>
            )}
            <div className="flex flex-col gap-y-2 text-base">
              {tokenState && showMeta && (
                <>
                  <div className="flex flex-col gap-1">
                    <CopyToClipboard
                      text={`${
                        import.meta.env.VITE_APP_URL
                      }/demo?token=${tokenState}&redirect_url=${redirectUrl}`}
                      onCopy={() => openSnackBar({ message: "Link copied" })}
                      options={{ format: "text/plain" }}
                    >
                      <div className="flex space-between w-full items-center">
                        <p style={{ marginTop: 0 }}>
                          With Meta Quest courses redirect:
                        </p>
                        <FileCopyIcon
                          variant="contained"
                          // disableElevation
                          className="cursor-pointer"
                          style={{ marginLeft: "10px", width: "14px" }}
                        />
                      </div>
                    </CopyToClipboard>
                    <div className="font-mono break-all text-sm">{`${
                      import.meta.env.VITE_APP_URL
                    }/demo?token=${tokenState}&redirect_url=${redirectUrl}`}</div>
                  </div>
                </>
              )}
            </div>
          </div>
          <div className="flex flex-col gap-y-2">
            <p className="">Redirect to course:</p>
            <select
              id="course-select2"
              className="block w-full rounded-md border-0 px-2 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-black sm:text-sm sm:leading-6"
              defaultValue={courseIdSelect}
              onChange={(e) => changeSelected(e)}
              onBlur={() => {
                return
              }}
            >
              {filteredCourses?.map((course) => (
                <option key={course.id} value={course.container_id}>
                  {course.name}
                </option>
              ))}
            </select>
            {!tokenState && !showCourse && (
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  createDemoUser()
                  setShowCourse(true)
                }}
              >
                Get Course Link
              </Button>
            )}
            {tokenState && !showCourse && (
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  setShowCourse(true)
                }}
              >
                Get Course Link
              </Button>
            )}
          </div>
        </>
        <div className="flex flex-col text-base gap-y-2">
          {tokenState && showCourse && (
            <div className="flex flex-col gap-1">
              <CopyToClipboard
                text={`${
                  import.meta.env.VITE_APP_URL
                }/demo?token=${tokenState}&container_id=${courseIdSelect}`}
                onCopy={() => openSnackBar({ message: "Link copied" })}
                options={{ format: "text/plain" }}
              >
                <div className="flex space-between w-full items-center">
                  <p style={{ marginTop: 0 }}>
                    With course container ID redirect:
                  </p>
                  <FileCopyIcon
                    variant="contained"
                    // disableElevation
                    className="cursor-pointer"
                    style={{ marginLeft: "10px", width: "14px" }}
                  />
                </div>
              </CopyToClipboard>
              <div className="font-mono break-all text-sm">{`${
                import.meta.env.VITE_APP_URL
              }/demo?token=${tokenState}&container_id=${courseIdSelect}`}</div>
            </div>
          )}
        </div>
      </div>
    </Dialog>
  )
}

DemoTokenDialog.propTypes = {
  open: PropTypes.bool,
  handleCloseToken: PropTypes.func,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  currentRefetchId: PropTypes.number,
  setCurrentRefetchId: PropTypes.func,
  showCourse: PropTypes.bool,
  showMeta: PropTypes.bool,
  setShowCourse: PropTypes.func,
  setShowMeta: PropTypes.func,
}
